import { PropertiesAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IGetPropertiesDTO, IGetPropertiesResponse, IGetPropertyResponse } from '@/models/property.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PROPERTIES_SLICE_NAME } from './models';

type TGetPropertiesPayload = IGetPropertiesDTO & { isSold?: boolean };

export const getProperties = createAsyncThunk<
  IGetPropertiesResponse,
  TGetPropertiesPayload,
  { serializedErrorType: IApiError }
>(
  `${PROPERTIES_SLICE_NAME}/getProperties`,
  async (data) => {
    const { isSold, ...dto } = data;
    const response = await PropertiesAPI.getProperties(dto, isSold ?? false);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getProperty = createAsyncThunk<IGetPropertyResponse, string, { serializedErrorType: IApiError }>(
  `${PROPERTIES_SLICE_NAME}/getProperty`,
  async (id) => {
    const response = await PropertiesAPI.getProperty(id);
    return response.data;
  },
  { serializeError: formatApiError },
);
